<template>
  <div class="container-xxl flex-grow-1 container-p-y">
    <div class="row mt-4">
      <div class="col-md-8 col-12">
        <div class="accordion accordion-header-primary" id="accordionStyle1">
          <div class="accordion-item card p-5 pt-0 pb-4">
            <h2 class="accordion-header">
              <div type="button" class="d-flex justify-content-between align-items-center" data-bs-toggle="collapse"
                data-bs-target="#accordionStyle1-1" aria-expanded="true">
                <div>
                  <small class="text-muted">April 2025 / 568154</small><br>
                  <div class="d-flex justify-content-start mt-n2">
                    <h2 class="mb-0 text-primary">549.90</h2>
                    <sub class="h5 pricing-currency mb-auto mt-1 text-primary">₺</sub>
                  </div>
                </div>
                <div class="text-end">
                  <span class="alert alert-solid-danger text-xs"> unpaid </span><br>
                  <i class="ti ti-chevron-right text-muted"></i>
                </div>
              </div>
            </h2>

            <div id="accordionStyle1-1" class="accordion-collapse collapse" data-bs-parent="#accordionStyle1">
              <hr class="mb-8 mt-2">
              <div class="accordion-body">
                <div class="row">
                  <div class="col-12">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-wifi"></i>
                      </span>
                      Subscription:
                      <strong class="ms-2">Özgür İletişim Fiber 100</strong>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-currency-lira"></i>
                      </span>
                      Price:
                      <strong class="ms-2">500,65 TL</strong>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-check"></i>
                      </span>
                      Paid:
                      <strong class="ms-2 text-danger">No</strong>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-calendar-minus"></i>
                      </span>
                      From:
                      <strong class="ms-2">26/02/2025</strong>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-calendar-plus"></i>
                      </span>
                      To:
                      <strong class="ms-2">26/03/2025</strong>
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-file-description"></i>
                      </span>
                      Notes:
                      <strong class="ms-2">Late fee 0,62 TL included</strong>
                    </div>
                  </div>
                </div>
              </div>
              <hr class="mb-2">
              <div class="row mb-4">
                <div class="col-md-3">
                  <div class="d-grid w-100 mt-4">
                    <button type="button" class="btn btn-success" @click="">
                      <i class="ti ti-cash me-2"></i>
                      <span>Pay</span>
                    </button>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="d-grid w-100 mt-4">
                    <button class="btn btn-info" @click="">
                      <i class="ti ti-printer me-2"></i>
                      <span>Print</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="accordion-item card p-5 pt-0 pb-4">
            <h2 class="accordion-header">
              <div type="button" class="d-flex justify-content-between align-items-center" data-bs-toggle="collapse"
                data-bs-target="#accordionStyle1-2" aria-expanded="true">
                <div>
                  <small class="text-muted">April 2025 / 568154</small><br>
                  <div class="d-flex justify-content-center">
                    <h2 class="mb-0 text-primary">549.90</h2>
                    <sub class="h5 pricing-currency mb-auto mt-1 text-primary">₺</sub>
                  </div>
                </div>
                <div class="text-end">
                  <span class="alert alert-solid-success text-xs"> Paid </span><br>
                  <i class="ti ti-chevron-right text-muted"></i>
                </div>
              </div>
            </h2>

            <div id="accordionStyle1-2" class="accordion-collapse collapse" data-bs-parent="#accordionStyle1">
              <hr class="mb-8 mt-2">
              <div class="accordion-body">
                <div class="row">
                  <div class="col-12">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-wifi"></i>
                      </span>
                      Subscription:
                      <strong class="ms-2">Özgür İletişim Fiber 100</strong>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-currency-lira"></i>
                      </span>
                      Price:
                      <strong class="ms-2">500,65 TL</strong>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-check"></i>
                      </span>
                      Paid:
                      <strong class="ms-2 text-success">Yes</strong>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-calendar-minus"></i>
                      </span>
                      From:
                      <strong class="ms-2">26/02/2025</strong>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-calendar-plus"></i>
                      </span>
                      To:
                      <strong class="ms-2">26/03/2025</strong>
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-file-description"></i>
                      </span>
                      Notes:
                      <strong class="ms-2">Late fee 0,62 TL included</strong>
                    </div>
                  </div>
                </div>
              </div>
              <hr class="mb-5">
              <div class="row mb-4">
                <div class="col-md-3">
                  <div class="d-grid w-100 mt-4">
                    <button type="button" class="btn btn-success" @click="">
                      <i class="ti ti-cash me-2"></i>
                      <span>Pay</span>
                    </button>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="d-grid w-100 mt-4">
                    <button class="btn btn-info" @click="">
                      <i class="ti ti-printer me-2"></i>
                      <span>Print</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="accordion-item card p-5 pt-0 pb-4">
            <h2 class="accordion-header">
              <div type="button" class="d-flex justify-content-between align-items-center" data-bs-toggle="collapse"
                data-bs-target="#accordionStyle1-3" aria-expanded="true">
                <div>
                  <small class="text-muted">April 2025 / 568154</small><br>
                  <div class="d-flex justify-content-center">
                    <h2 class="mb-0 text-primary">549.90</h2>
                    <sub class="h5 pricing-currency mb-auto mt-1 text-primary">₺</sub>
                  </div>
                </div>
                <div class="text-end">
                  <span class="alert alert-solid-success text-xs"> Paid Paid Paid </span><br>
                  <i class="ti ti-chevron-right text-muted"></i>
                </div>
              </div>
            </h2>

            <div id="accordionStyle1-3" class="accordion-collapse collapse" data-bs-parent="#accordionStyle1">
              <hr class="mb-8 mt-2">
              <div class="accordion-body">
                <div class="row">
                  <div class="col-12">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-wifi"></i>
                      </span>
                      Subscription:
                      <strong class="ms-2">Özgür İletişim Fiber 100</strong>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-currency-lira"></i>
                      </span>
                      Price:
                      <strong class="ms-2">500,65 TL</strong>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-check"></i>
                      </span>
                      Paid:
                      <strong class="ms-2 text-success">Yes</strong>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-calendar-minus"></i>
                      </span>
                      From:
                      <strong class="ms-2">26/02/2025</strong>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-calendar-plus"></i>
                      </span>
                      To:
                      <strong class="ms-2">26/03/2025</strong>
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-file-description"></i>
                      </span>
                      Notes:
                      <strong class="ms-2">Late fee 0,62 TL included</strong>
                    </div>
                  </div>
                </div>
              </div>
              <hr class="mb-5">
              <div class="row mb-4">
                <div class="col-md-3">
                  <div class="d-grid w-100 mt-4">
                    <button type="button" class="btn btn-success" @click="">
                      <i class="ti ti-cash me-2"></i>
                      <span>Pay</span>
                    </button>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="d-grid w-100 mt-4">
                    <button class="btn btn-info" @click="">
                      <i class="ti ti-printer me-2"></i>
                      <span>Print</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="accordion-item card p-5 pt-0 pb-4">
            <h2 class="accordion-header">
              <div type="button" class="d-flex justify-content-between align-items-center" data-bs-toggle="collapse"
                data-bs-target="#accordionStyle1-4" aria-expanded="true">
                <div>
                  <small class="text-muted">April 2025 / 568154</small><br>
                  <div class="d-flex justify-content-center">
                    <h2 class="mb-0 text-primary">549.90</h2>
                    <sub class="h5 pricing-currency mb-auto mt-1 text-primary">₺</sub>
                  </div>
                </div>
                <div class="text-end">
                  <span class="alert alert-solid-success text-xs"> Paid Paid Paid </span><br>
                  <i class="ti ti-chevron-right text-muted"></i>
                </div>
              </div>
            </h2>

            <div id="accordionStyle1-4" class="accordion-collapse collapse" data-bs-parent="#accordionStyle1">
              <hr class="mb-8 mt-2">
              <div class="accordion-body">
                <div class="row">
                  <div class="col-12">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-wifi"></i>
                      </span>
                      Subscription:
                      <strong class="ms-2">Özgür İletişim Fiber 100</strong>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-currency-lira"></i>
                      </span>
                      Price:
                      <strong class="ms-2">500,65 TL</strong>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-check"></i>
                      </span>
                      Paid:
                      <strong class="ms-2 text-success">Yes</strong>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-calendar-minus"></i>
                      </span>
                      From:
                      <strong class="ms-2">26/02/2025</strong>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-calendar-plus"></i>
                      </span>
                      To:
                      <strong class="ms-2">26/03/2025</strong>
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-file-description"></i>
                      </span>
                      Notes:
                      <strong class="ms-2">Late fee 0,62 TL included</strong>
                    </div>
                  </div>
                </div>
              </div>
              <hr class="mb-5">
              <div class="row mb-4">
                <div class="col-md-3">
                  <div class="d-grid w-100 mt-4">
                    <button type="button" class="btn btn-success" @click="">
                      <i class="ti ti-cash me-2"></i>
                      <span>Pay</span>
                    </button>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="d-grid w-100 mt-4">
                    <button class="btn btn-info" @click="">
                      <i class="ti ti-printer me-2"></i>
                      <span>Print</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-12 d-md-block d-none">
        <div class="card">
          <img class="card-img" src="@/assets/img/elements/4.jpg" alt="Card image cap" />
        </div>
      </div>
    </div>

  </div>
</template>
<script>

</script>
